import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  zip: "",
  city: "",
  state: "",
  country: "",
};

const stateSlice = createSlice({
  name: "state",
  initialState,
  reducers: {
    setUpdateZip: (state, action) => {
      state.zip = action.payload;
    },
    setUpdateCity: (state, action) => {
      state.city = action.payload;
    },
    setUpdateState: (state, action) => {
      state.state = action.payload;
    },
    setUpdateCountry: (state, action) => {
      state.country = action.payload;
    },
    resetState: (state) => {
      state.zip = initialState.zip;
      state.city = initialState.city;
      state.state = initialState.state;
      state.country = initialState.country;
    },
  },
});

export const {
  setUpdateZip,
  setUpdateCity,
  setUpdateState,
  setUpdateCountry,
  resetState,
} = stateSlice.actions;

export const selectZip = state => state.state.zip;
export const selectCity = state => state.state.city;
export const selectState = state => state.state.state;
export const selectCountry = state => state.state.country;

export default stateSlice.reducer;
